module.exports = __webpack_public_path__ + "static/img/img-about-8-1.e4ba073.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-8-1.png
// module id = DYY9
// module chunks = 0